'use strict';

var UserManagementUsersService = function UserManagementUsersService(SearchCriteriaRule) {
  function getUserSearchCriteria() {
    var searchCriterias = [];
    var inactiveUserCriteria = new SearchCriteriaRule({
      field: 'isActive',
      operator: '=',
      leftOperand: true
    });
    searchCriterias.push(inactiveUserCriteria);
    return searchCriterias;
  }
  return {
    getUserSearchCriteria: getUserSearchCriteria
  };
};
UserManagementUsersService.$inject = ['SearchCriteriaRuleFactory'];
module.exports = UserManagementUsersService;